import React from "react";
import { Link } from 'react-router-dom';

export default function CategoryCard(props: { currentUrl: string, name: string, slug: string, isParent: boolean }) {
    const { currentUrl, name, slug, isParent } = props;
    return (
        <>
            {isParent ?
                <div className="kachel main-category" style={{ backgroundImage: `url("/icons/${slug}.svg")` }}>
                    <Link state={{ fromInternal: true }}
                        to={`/${slug}`}
                        className="link">

                    </Link>
                    <span>{name}</span>
                </div>
                :
                <Link state={{ fromInternal: true }}
                    style={{ backgroundImage: `url("/icons/${slug}.svg")` }}
                    className="kachel child-category"
                    to={`/${currentUrl}/${slug}`}>
                    {name}
                </Link>
            }
        </>
    )
}

